import { get } from "svelte/store";
import ApiParams from "@/lib/stores/ApiParams";
import { fetchSelfService } from "./helpers";
import { type TableCategoryGroupResponse } from "./category.types";

let apiParams = get(ApiParams);

export function getFacetParams(): Record<string, string> {
  let facetObj: Record<string, string> = {};
  let urlParams = new URL(window.location.toString()).searchParams;
  for (let [key, value] of urlParams.entries()) {
    if (key.includes("facet")) {
      facetObj[key] = value;
    }
  }
  return facetObj;
}

export function getTableCategoryGroup({
  id,
  searchMode = "category",
  groupItems = true,
  groupName,
  pageNumber,
  pageSize,
  orderBy,
  sortDirection = "asc",
  facets = {},
  beginIndex, // Added new parameter
}): Promise<TableCategoryGroupResponse> {
  const params: Record<string, string> = {
    searchMode,
    groupItems,
    groupName,
    pageNumber,
    pageSize,
    langId: apiParams.langId,
    catalogId: apiParams.catalogId,
    ...facets,
  };

  // Only add beginIndex if it's provided and greater than 0
  if (typeof beginIndex === "number" && beginIndex > 0) {
    params.beginIndex = beginIndex.toString();
  }

  if (orderBy) {
    params.orderBy = orderBy + " " + sortDirection;
  }
  const searchParams = new URLSearchParams(params);
  return fetchSelfService({
    endpoint: `wcs/resources/store/${apiParams.storeId}/hdsproductview/byCategory/${id}`,
    queryParams: searchParams.toString(),
  });
}

// removed groupName and it works
export function getListHtmlGroup({ categoryId, groupName, resultsPerPage, beginIndex, facets = {} }): Promise<string> {
  const params: Record<string, string> = {
    resultsPerPage,
    beginIndex,
    categoryId,
    groupName,
    disableProductCompare: false,

    langId: apiParams.langId,
    catalogId: apiParams.catalogId,
    storeId: apiParams.storeId,
    ...facets,
  };
  const searchParams = new URLSearchParams(params);
  return fetchSelfService({
    endpoint: `ProductListingViewV2`,
    queryParams: searchParams.toString(),
  });
}

export function getHtmlByPartNumber({ partNumber }): Promise<string> {
  const params: Record<string, string> = {
    partNumber,
    disableProductCompare: false,
    includeProductListingAvailability: true,
    ajaxStoreDir: "HDSB2BV2StorefrontAssetStore",
    langId: apiParams.langId,
    catalogId: apiParams.catalogId,
    storeId: apiParams.storeId,
  };
  const searchParams = new URLSearchParams(params);
  return fetchSelfService({
    endpoint: `HdsCatalogEntryDisplayView`,
    queryParams: searchParams.toString(),
  });
}
